<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentStatus === 'D' || row.shipmentStatus === 'R'
              ? 'warning'
              : row.shipmentStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_shipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo, sourceType: 'waitBooking' },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo, sourceType: 'waitBooking' },
                })
              "
            ></i>
          </el-tooltip>
          <el-dropdown trigger="click" @command="exportFile" v-if="allow('E')">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_export') || '导出'"
              placement="top"
            >
              <i class="el-icon-download tool-btn"></i>
            </el-tooltip>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="task in exportTasks"
                :key="task.templateGroup"
                :command="{ ...row, ...task }"
              >
                {{ task.exportName }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_waitBookingCompleted') || '订舱完成'"
            placement="top"
            v-if="allow('C')"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="bookingCompleted(row.shipmentCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="回退"
            placement="top"
            v-if="allow('D')"
          >
            <i class="el-icon-refresh-left tool-btn" @click="rollback(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <back-form
      :visible.sync="backFormDialogVisible"
      :shipmentCode="backFormDialogOption.shipmentCode"
      :shipmentStatus="backFormDialogOption.shipmentStatus"
      :title="backFormDialogOption.title"
      @reload="() => this.$emit('reload')"
    />

    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { shipmentCode: chooseTemplateOptions.shipmentCode },
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import exportTasks from './export-tasks'
import EditLoading from '@/mixins/edit-loading'
import ChooseTemplate from '@/views/factory/transport/components/choose-template'
import BackForm from '../back-form'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { BackForm, ChooseTemplate },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      exportTasks: exportTasks(this),
      backFormDialogVisible: false,
      backFormDialogOption: {
        visbile: false,
        shipmentCode: '',
        shipmentStatus: '',
        title: this.$l('form_back_reason') || '回退原因',
      },
      chooseTemplateOptions: {
        visible: false,
        shipmentCode: '',
        custCode: '',
        endCustCode: '',
        templateGroup: '',
        exportCheckUrl: '',
      },
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-wait-booking-detail',
        params: { ...params, pageType },
        query,
      })
    },
    rollback(row) {
      this.$confirm(
        '确认要回退发运单【' + row.shipmentNo + '】吗？',
        '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .shipmentInfoBookingBackCheckReasonApi({
            shipmentCode: row.shipmentCode,
            shipmentStatus: row.shipmentStatus,
          })
          .then((res) => {
            const { body, status, msg } = res
            if (status != 200) {
              this.$message.error(msg)
              return
            }
            if (body) {
              this.backFormDialogVisible = true
              this.backFormDialogOption.shipmentCode = row.shipmentCode
              this.backFormDialogOption.shipmentStatus = row.shipmentStatus
            } else {
              this.bookingBack(row)
            }
          })
      })
    },
    bookingBack({ shipmentCode, shipmentStatus }) {
      this.loadingOpen()
      this.$api
        .shipmentInfoBookingBackApi({
          shipmentCode: shipmentCode,
          shipmentStatus: shipmentStatus,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    rollbackSubmit(shipmentCode, shipmentStatus) {
      this.loadingOpen()
      this.$api
        .shipmentInfoBackApi({
          shipmentCode: shipmentCode,
          shipmentStatus: shipmentStatus,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    bookingCompleted(shipmentCode) {
      this.$confirm(
        this.$l('tips_waitBookingCompleted') || '是否要进行订舱完成操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .shipmentInfoBookingCompletedApi({ shipmentCode: shipmentCode })
            .then((res) => {
              this.loadingClose()
              const { status, msg: message } = res

              if (status === 200) {
                this.$message({
                  showClose: true,
                  message,
                  type: 'success',
                })
                this.$emit('reload')
                return
              }

              if (status === 203) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  message,
                  type: 'error',
                  duration: 5000,
                  showClose: true,
                  customClass: 'booking-message',
                })
                return
              }
              this.$message.error(message)
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {})
    },
    exportFile({
      shipmentCode,
      custCode,
      endCustCode,
      templateGroup,
      exportCheckUrl,
    }) {
      this.chooseTemplateOptions = {
        visible: true,
        shipmentCode,
        custCode,
        endCustCode,
        templateGroup,
        exportCheckUrl,
      }
    },
  },
}
</script>
<style lang="scss">
.booking-message {
  p.el-message__content {
    > p {
      line-height: 28px;
      strong {
        margin-left: 4px;
      }
    }
  }
}
</style>
